export default function Close(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.07938 14.5845V8.50059H0V6.64628H6.07938V0.584473H7.93164V6.64628H14V8.50059H7.93164V14.5845H6.07938Z" fill={props?.color || 'black'} />
        </svg>
    );
}
